export default {
  selectedSliderTabIndex: 0
}
